/**
 * IP_Define.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

const IP_Define = (function(){

    // [D] private variables

    // [D] private functions

	return class {

		// @DES :: Interpreter Type
		static get IP_TYPE() {
			return {
				'wait' : 0,
				'init' : 1,
				'step' : 2,
				'stop' : 3
			}
		}

		// @DES :: Interpreter Type
		static get MESSAGE() {
			return {
				"NO_CODE" : "[코드모스] => interpreter의 code가 없습니다.",
				"NO_SCOPE" : "[코드모스] => interpreter의 scope가 없습니다.",
				"NO_INIT" : "[코드모스] => interpreter의 초기화가 진행되지 않았습니다.",
				"DO_STEP" : "[코드모스] => interpreter가 진행중입니다."
			}
		}

		// @DES :: STOP_STEP_METHOD_NAME
		static get STOP_STEP_METHOD_NAME() {
			return '_stopStep';
		}



	}
}());

export default IP_Define;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/interpreter/dev/util/IP_Define.js